import Vue from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import EventBus from '../event-bus.js';

import utils from '../../Shared/utils.jsx';
import methods from '../../Shared/methods';

Vue.component('interval', {
    mixins: [BaseComponent],
    data: function () {
        return {
            delay_expn: 0,
            count_expn: 0,
            counter: 0,
            actions: [],
            actions_compiled: false,
        }
    },
    computed: {
    },
    created() {
        this.delay_expn = utils.compileExpression(this, this.controlData.Delay);

        if (this.controlData.Count) {
            this.count_expn = utils.compileExpression(this, this.controlData.Count);
            this.counter = utils.evaluate(this.count_expn, this);
        }
    },
    //Mounted Replaced with preRenderComplete
    destroyed() {
        this.Stop();
    },
    methods: {
        preRenderComplete() {
            if (this.controlData.StartImmediately)
                this.Start();
            this.finishRenderHandler(this);

            if (this.controlData.RunActionsOnLoad)
                this.invokeActions();
        },
        Start() {
            const delay = utils.evaluate(this.delay_expn, this);

            if (!this.interval) {
                this.interval = setInterval(() => {
                    this.invokeActions();

                    if (this.counter > 0) {
                        this.counter--;

                        if (this.counter <= 0) {
                            clearInterval(this.interval);
                            this.interval = null;
                        }
                    }
                }, delay);
            }
        },
        Stop() {
            if (this.interval)
                clearInterval(this.interval);

            this.interval = null;
        },
        async invokeActions() {
            if (this.controlData.Actions && !this.actions_compiled) {
                for (var i = 0; i < this.controlData.Actions.length; i++)
                    try {
                        const a = await utils.compileAction(this, this.controlData.Actions[i])
                        if (a)
                            this.actions.push(a);
                    }
                    catch (e) {
                        utils.error(`BroadcastListener ${this.name} Actions[${i}] error compiling: ${e}`);
                    }

                this.actions_compiled = true;
            }

            for (var i = 0; i < this.actions.length; i++)
                await utils.executeAction(this.actions[i], null, this);
        }
    },
    props: {
    },
    render(h) {
        return null;
    }
});